import { PREDICT_PRODUCT_SLUG } from '@futrli/shared-services/app-core/constants';

export const STRIPE_SCRIPT_URL = 'https://js.stripe.com/v3/';

export const PREDICT_BILLING_PRODUCT = { name: 'Predict', slug: PREDICT_PRODUCT_SLUG };

/**
 * @TODO Currently there is no way of getting the integration level of an specific product,
 * the billing_model property coming from app store is not longer valid, so we are hardcoding
 * premium until BE implement this properly. The value premium is due to it is the option which
 * the api is working with.
 */
export const INTEGRATION_LEVEL = 'premium';

export const YEAR_MONTHS = 12;

export const TRACKING_EVENTS = {
  PURCHASED_SUBSCRIPTION_DIRECT: 'Purchased Subscription - Direct',
  PURCHASED_SUBSCRIPTION_DIRECT_SALES_PORTAL: 'Purchased Subscription - Sales portal'
};
